<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="23" viewBox="0 0 22 23" fill="currentColor">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M1.99992 0.666672C1.07944 0.666672 0.333252 1.41287 0.333252 2.33334V20.6667C0.333252 21.5872 1.07945 22.3333 1.99992 22.3333H14.4999C14.9601 22.3333 15.3333 21.9602 15.3333 21.5C15.3333 21.0398 14.9601 20.6667 14.4999 20.6667H1.99992V2.33334H14.4999C14.9601 2.33334 15.3333 1.96024 15.3333 1.50001C15.3333 1.03977 14.9601 0.666672 14.4999 0.666672H1.99992ZM18.0059 7.16076C17.6804 6.83531 17.1528 6.83531 16.8273 7.16076C16.5019 7.48619 16.5019 8.01382 16.8273 8.33925L19.1548 10.6667H7.83325C7.37302 10.6667 6.99992 11.0398 6.99992 11.5C6.99992 11.9602 7.37302 12.3333 7.83325 12.3333H19.1548L16.8273 14.6608C16.5019 14.9862 16.5019 15.5138 16.8273 15.8393C17.1528 16.1647 17.6804 16.1647 18.0059 15.8393L21.7559 12.0893C22.0813 11.7638 22.0813 11.2362 21.7559 10.9108L18.0059 7.16076Z" />
  </svg>
</template>
<style scoped>
svg {
  color: #59E3FF;
  transition: color 0.3s ease-in-out;
}
</style>
